import styled from 'styled-components/native';
import { H3 } from '../../config/designSystem/typography';


export const SectionTitle = styled(H3)`
  paddingBottom: 24px;
`;

